import CustomerInvestPolicy from "./containers/CustomerInvestPolicy";
import JoinPersonalDetails from "./containers/JoinPersonalDetails";
import PleaseWait from "./containers/PleaseWait";
import DisabledJoinPersonalDetails from "./containers/DisabledJoinPersonalDetails";
import Lobby from "./containers/Lobby";
import DeepLink from "./containers/DeepLink";

import ContactLink from "./containers/ContactLink";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// import './styles/bootstrap-loader.scss';
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact
          path='/JoinPersonalDetails'
          element={<JoinPersonalDetails />} />
        <Route exact path="/DeepLink" element={<DeepLink />} />
        <Route exact path="/ContactLink" element={<ContactLink />} />
        <Route
          exact
          path="/CustomerInvestPolicy"
          element={<CustomerInvestPolicy />}
        />
        <Route exact path="/PleaseWait" element={<PleaseWait />} />
        <Route exact path="/Lobby" element={<Lobby />} />
        <Route
          exact
          path="/DisabledJoinPersonalDetails"
          element={<DisabledJoinPersonalDetails />}
        />
        <Route
          path="*"
          element={<Navigate to="/CustomerInvestPolicy" replace />}
        />
        {/* <Route component={NotFoundPage} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
